export default __webpack_public_path__ + "static/media/homePage_img.137190ab.png";